import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";
import { AdminProductsService } from "../../../pages/admin-pages/products/services/admin-products.service";
import { AdminProductsActions } from "../../actions/admin-products.actions";
import { FailState } from "../../models/fail-state";
import { ProductFamiliesState } from "../../models/mp-admin/product-families-state";
import { AppState } from "../../reducers";
import { AdminProductsSelectors } from "../../selectors/admin-products.selectors";

@Injectable()
export class ProductFamiliesEffects {
	productFamilies = createEffect(() =>
		this.actions.pipe(
			ofType(AdminProductsActions.productFamilies.get),
			withLatestFrom(this.store.select(AdminProductsSelectors.productFamilies)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(state)
					? of(AdminProductsActions.productFamilies.getSuccess({ state }))
					: of(AdminProductsActions.productFamilies.getApi())
			)
		)
	);

	productFamiliesApi = createEffect(() =>
		this.actions.pipe(
			ofType(AdminProductsActions.productFamilies.getApi),
			switchMap(() =>
				this.service.getProductFamilies().pipe(
					map((families) =>
						AdminProductsActions.productFamilies.getSuccess({
							state: { families, loading: false, hasLoaded: true }
						})
					),
					catchError((error) =>
						of(AdminProductsActions.productFamilies.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private service: AdminProductsService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(state: ProductFamiliesState): boolean {
		return (
			state !== undefined &&
			!_.has(state, "error") &&
			!state.loading &&
			state.hasLoaded === true &&
			_.has(state, "families") &&
			state.families !== undefined
		);
	}
}
